import { Column, SortDirection } from '@tanstack/react-table';
import { ChevronDown, ChevronsUpDown, ChevronUp } from 'lucide-react';
import { cn } from '../../utils/cn';
import { exhaustiveCheck } from '../../utils/exhaustive-check';
import { Button } from '../button/button';

type ColumnHeaderWithSortingProps<TData> = {
  column: Column<TData>;
  label: string;
};

export const ColumnHeaderWithSorting = <TData,>({ column, label }: ColumnHeaderWithSortingProps<TData>) => {
  const sortDirection = column.getIsSorted();
  const sortingIcon = getSortingIcon({ sortDirection });
  const isAmountColumn = ['amount', 'transactions', 'money_in', 'money_out', 'balance'].includes(column.id);

  return (
    // The column amount header left aligned doesn't look good with right aligned amounts
    <div className={cn('flex items-center gap-1', isAmountColumn ? 'justify-end' : 'justify-start')}>
      <p className="text-nowrap">{label}</p>

      <Button
        variant="ghost"
        aria-label="Sort column"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          column.getToggleSortingHandler()?.(e);
        }}
        className="p-0"
      >
        {sortingIcon}
      </Button>
    </div>
  );
};

type GetSortingIconArgs = {
  sortDirection: false | SortDirection;
};

const getSortingIcon = ({ sortDirection }: GetSortingIconArgs) => {
  switch (sortDirection) {
    case false:
      return <ChevronsUpDown size={16} />;
    case 'asc':
      return <ChevronUp size={16} />;
    case 'desc':
      return <ChevronDown size={16} />;
    default:
      return exhaustiveCheck(sortDirection);
  }
};
